export default __webpack_public_path__ + "static/media/mv.8cb05cc8.svg";